import { getNextPage } from '@/modules/FileList/utils/getNextPage';
import { infiniteQueryOptions } from '@tanstack/react-query';
import { WalletFileListQueryParamsType } from './walletFileListQuery.type';
import { walletFileListFunction } from './walletFileListQueryFunction';

export const walletFileListQueryOptions = (
  params: WalletFileListQueryParamsType,
  enabled: boolean = true,
) => {
  return infiniteQueryOptions({
    queryKey: ['file-list', params],
    queryFn: ({ pageParam }) =>
      walletFileListFunction({ ...params, page: pageParam }),
    initialPageParam: 1,
    getNextPageParam: getNextPage,
    enabled,
  });
};
